import { fetchUserAndAccountData } from '../shared/zapierApi';

/**
 * This is the entrypoint for the customizable script.js file that runs on the ZDG Theme settings
 */
export const initializeWootricScript = async () => {
  console.log('Initializing Wootric script...');

  const styles = `
  :root {
    --Colors-zapier: #ff4f00;
    --Colors-earth: #201515;
    --Colors-blueJeans: #3d4592;
    --Colors-neutral100: #fffdf9;
    --Colors-neutral600: #95928e;
    --Colors-neutral700: #403f3e;
    --Colors-neutral800: #2d2e2e;
    --Shadows-elevation20: #eee 0px 10px 30px 0px;
    --defaultFont: 'Degular', Helvetica, arial, sans-serif;
    --altFont: 'Inter', Helvetica, arial, sans-serif;
    --smallPrint-fontFamily: var(--altFont);
    --smallPrint-fontSize: 14px;
    --smallPrint-lineHeight: 20px;
    --smallPrint-fontWeight: 400;
    --smallPrintBold-fontWeight: 700;
    --paragraph3-fontFamily: var(--defaultFont);
    --paragraph3-fontSize: 16px;
    --paragraph3-lineHeight: 24px;
    --paragraph3-fontWeight: 400;
    --paragraph3Medium-fontWeight: 500;
    --paragraph3Semibold-fontWeight: 600;
    --subHeader1-fontFamily: var(--defaultFont);
    /* Lowered subheader1 font size at Nikki's request, was 24px */
    --subHeader1-fontSize: 20px;
    /* Lowered subheader1 line height to compress modal slightly, was 30px */
    --subHeader1-lineHeight: 26px;
    --subHeader1-fontWeight: 400;
    --subHeader1Semibold-fontWeight: 600;
  }

  @media only screen and (max-width: 660px) {
    #wootric-modal {
      display: none !important;
      visibility: hidden !important;
    }
  }
  
  @media only screen and (max-width: 780px) {
    #wootric-modal.wootric-desktop-modal #wootric-not-likely-label, #wootric-modal.wootric-desktop-modal #wootric-likely-label {
      display: block !important; 
    }  
  }

  .wootric-beacon-parent {
    width: 600px !important;
  }
  
  #wootric-modal {
    display: flex;
    justify-content: center;
    font-family: var(--defaultFont);
    border: 0 none transparent;
    margin: 0 auto;
    width: 600px !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent {
    background-color: var(--Colors-neutral100);
    box-shadow: var(--Shadows-elevation20);
    border-top: 5px solid var(--Colors-blueJeans) !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form p {
      font-family: var(--defaultFont) !important;
      letter-spacing: 0.5px !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form li,
  #wootric-modal > div.wootric-beacon-parent #wootric-form label {
    font-family: var(--altFont) !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form div.wootric-question,
  #wootric-modal > div.wootric-beacon-parent #wootric-form div.thanks {
    padding-top: 12px;
    padding-bottom: 10px;
    margin-bottom: 0;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form div.wootric-question p,
  #wootric-modal > div.wootric-beacon-parent #wootric-form div.thanks p {
    font-family: var(--subHeader1-fontFamily);
    font-size: var(--subHeader1-fontSize);
    line-height: var(--subHeader1-lineHeight);
    font-weight: var(--subHeader1Semibold-fontWeight);
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #picklist {
    margin-bottom: 13px;
  }

  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-feedback {
    max-width: 431px;
    display: flex;
    justify-content: center;
    margin: 0 auto 25px auto;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-feedback .shadow-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-feedback textarea {
    border-radius: 3px;
    border-color: var(--Colors-neutral600);
    background-color: var(--Colors-neutral100);
    width: 100%;
    height: 30px;
    padding: 4px 11px;
    font-family: var(--smallPrint-fontFamily) !important;
    font-size: var(--smallPrint-fontSize);
    line-height: var(--smallPrint-lineHeight);
    font-weight: var(--paragraph3Medium-fontWeight);
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-feedback input {
    border-radius: 3px !important;
    border: none;
    background-color: var(--Colors-blueJeans);
    margin-left: 6px !important;
    font-family: var(--smallPrint-fontFamily);
    font-size: var(--smallPrint-fontSize);
    font-weight: 600;
    width: 72px;
    line-height: var(--smallPrint-lineHeight);
    height: 30px !important;
    padding: 0 14px !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form .wootric-alt-anchors {
    display: none;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 21px;
    margin-bottom: 0;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 13px;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore ul li {
    border-radius: 3px;
    border-color: var(--Colors-neutral600);
    color: var(--Colors-neutral700);
    font-family: var(--smallPrint-fontFamily);
    font-size: var(--smallPrint-fontSize);
    line-height: var(--smallPrint-lineHeight);
    font-weight: var(--smallPrintBold-fontWeight);
    margin: 0 2px 4px 2px;
    padding: 5px 11px;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore ul li:hover,
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore ul li:focus {
    border: 1px solid var(--Colors-blueJeans) !important;
    color: var(--Colors-blueJeans) !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore ul li.selected {
    border: none !important;
    background-color: var(--Colors-neutral800) !important;
    color: var(--Colors-neutral100) !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore #wootric-likely-label,
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-fullscore #wootric-not-likely-label {
    font-family: var(--smallPrint-fontFamily);
    font-size: var(--smallPrint-fontSize);
    line-height: var(--smallPrint-lineHeight);
    font-weight: var(--smallPrint-fontWeight);
    color: var(--Colors-neutral700);
    font-style: normal;
    cursor: auto !important;
    padding-bottom: 0 !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close {
    border: none;
    font-size: 14px;
    width: 20px;
    height: 12px;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close #wootric-x {
    height: 12px;
    width: 12px;
    margin: 0 6px;
    color: var(--Colors-neutral700) !important;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close:hover, #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close:focus {
    background-color: var(--Colors-neutral100) !important;
    width: 80px;
  }
  
  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close #wootric-dismiss {
    font-family: var(--smallPrint-fontFamily);
    font-size: var(--smallPrint-fontSize);
    line-height: var(--smallPrint-lineHeight);
    font-weight: var(--smallPrint-fontWeight);
    color: var(--Colors-neutral700);  
  }


  #wootric-modal > div.wootric-beacon-parent #wootric-form #wootric-close #wootric-dismiss {
    text-transform: capitalize;
  }
  
  #wootric-modal > div.wootric-beacon-parent .wootric-powered-by {
    visibility: hidden;
  }
  
  #wootric-modal .wootric-footer {
    display: none !important;
  }
  `;

  const userAndAccountData = await fetchUserAndAccountData({});

  const {
    paying,
    is_trialing,
    is_trialing_companies,
    is_trialing_teams,
    period_start,
    period_end,
    plan_group_id,
    plan_info,
  } = userAndAccountData.accountData;

  const currentBillingPeriod = {
    from: period_start ? new Date(period_start) : undefined,
    to: period_end ? new Date(period_end) : undefined,
  };

  const planName = plan_info.name;

  const {
    email,
    current_account_id,
    id,
    roles,
    signup,
  } = userAndAccountData.userData;

  const currentUserRole =
    roles?.find(role => role.account_id === current_account_id) || {};

  // Use browser settings timezone and language - approved per Nikki Bown
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const language = Intl.DateTimeFormat().resolvedOptions().locale;

  let userCreatedAtUnix;
  if (signup) {
    userCreatedAtUnix = Math.floor(new Date(signup).getTime()) / 1000;
  }

  window.wootricSettings = {
    account_token: 'NPS-180ad05e',
    aria: true,
    created_at: userCreatedAtUnix,
    email,
    modal_footprint: 'compact',
    properties: {
      account_id: current_account_id,
      account_is_free: !paying,
      account_is_trialing: is_trialing,
      account_is_trialingCompanies: is_trialing_companies,
      account_is_trialingTeams: is_trialing_teams,
      customuser_id: id,
      date_last_charge: currentBillingPeriod.from?.toISOString(),
      date_next_charge: currentBillingPeriod.to?.toISOString(),
      date_user_created: userCreatedAtUnix,
      email,
      language,
      plan_group_id,
      plan_tier: planName,
      role: currentUserRole.role,
      timezone,
    },
  };

  const wootricScript = document.createElement('script');
  wootricScript.src = 'https://cdn.wootric.com/wootric-sdk.js';
  wootricScript.type = 'text/javascript';
  wootricScript.id = 'wootric-sdk';
  wootricScript.async = true;
  document.head.appendChild(wootricScript);

  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);

  wootricScript.addEventListener('load', function () {
    window.wootric('run');
  });
};
